import {Api} from '@lsgo/lsgo-fe'

export const api = new Api({location: window.location, application: 'lsgo_teacher_application'});

export default api.axiosInstance;